import { render } from "./CardChallengeRequestItem.vue?vue&type=template&id=1705a620&scoped=true"
import script from "./CardChallengeRequestItem.vue?vue&type=script&lang=js"
export * from "./CardChallengeRequestItem.vue?vue&type=script&lang=js"

import "@/css/components/card-challenge-request-item.css?vue&type=style&index=0&id=1705a620&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1705a620"]])

export default __exports__